import Splide from "@splidejs/splide/dist/js/splide.min.js";

export default function Carousel() {
  // HERO SLIDER
  document.querySelectorAll('[data-carousel="hero"]').forEach((el) => {
    new Splide(el, {
      type: "fade",
      autoplay: true,
      interval: 5000,
      pauseOnHover: false,
      arrows: false,
      pagination: false,
    }).mount();
  });

  // CARD CAROUSELS
  document.querySelectorAll('[data-carousel="cards"]').forEach((el) => {
    const type = el.dataset.carouselType || "slide";
    const rewind = el.dataset.carouselRewind === "true";
    const perMove = parseInt(el.dataset.carouselPerMove) || 1;

    // Get CSS variables
    const rootStyles = getComputedStyle(document.documentElement);
    const wrapperRaw = rootStyles.getPropertyValue("--wrapper");
    const rootFont = parseFloat(rootStyles.fontSize);
    const wrapperWidth = parseFloat(wrapperRaw) * rootFont;

    // Initialize Splide
    const splide = new Splide(el, {
      type: type,
      perMove: perMove,
      focus: 0,
      arrows: false,
      drag: true,
      pagination: false,
      preventClick: true,
      rewind: rewind,
      clones: 0,
      autoWidth: true,
      gap: "var(--row-gap)",
    });

    // Mount Splide
    splide.mount();

    // Arrow buttons
    const elParent = el.parentNode;
    const prevArrow = elParent.querySelector(".c-carousel__arrow--prev");
    const nextArrow = elParent.querySelector(".c-carousel__arrow--next");

    if (prevArrow) prevArrow.addEventListener("click", () => splide.go("<"));
    if (nextArrow) nextArrow.addEventListener("click", () => splide.go(">"));

    // Make links clickable
    el.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", (e) => e.stopPropagation());
    });
  });

  // PRODUCT GALLERY
  const galleryPairs = document.querySelectorAll(
    '[data-carousel="gallery-main"]',
  );

  galleryPairs.forEach((mainEl) => {
    const galleryId = mainEl.dataset.galleryId;
    const thumbEl = document.querySelector(
      `[data-carousel="gallery-thumbs"][data-gallery-id="${galleryId}"]`,
    );
    if (!thumbEl) return;

    const thumbSlider = new Splide(thumbEl, {
      type: "slide",
      perPage: parseInt(thumbEl.dataset.perPage) || 4,
      gap: "0.5rem",
      focus: "center",
      isNavigation: true,
      pagination: false,
      arrows: false,
    }).mount();

    const mainSlider = new Splide(mainEl, {
      type: "fade",
      pagination: false,
      arrows: true,
    });

    mainSlider.sync(thumbSlider).mount();

    mainEl.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", (e) => e.stopPropagation());
    });
  });
}
